import PaysSelectNat from '@/generated/controls/pays/PaysSelectNat.vue';
import Pays from '@/generated/classes/Pays';
import {defineComponent} from "vue";

export default defineComponent({
    components: {},
    extends: PaysSelectNat,
    methods: {
        getDisplay(pays: Pays): string {
            return pays.nationalite;
        }
    }
})
